<template>
  <div :class="$style.container">
    <div
      v-d-flex
      v-justify="{ content: 'stretch' }"
    >
      <base-button
        v-d-flex
        v-align="{ items: 'center' }"
        v-justify="{ content: 'center' }"
        v-border-radius="'50px'"
        :disabled="isMenuVisibility"
        style="width: 40px; height: 40px;"
        :class="[
          $style.button,
          $style.project,
          {
            [$style.active]: isActiveRoute('projects') || isActiveRoute('partners'),
          },
        ]"
        @click="$emit('navigate')"
      >
        <base-icon name="basic_menu-button"></base-icon>
      </base-button>
    </div>

    <div
      v-d-flex
      v-justify="{ content: 'stretch' }"
    >
      <base-button
        v-if="useSelfEmployed"
        v-d-flex
        v-align="{ items: 'center' }"
        v-justify="{ content: 'center' }"
        v-relative
        v-border-radius="'50px'"
        v-m-r="10"
        style="width: 40px; height: 40px;"
        :disabled="isMenuVisibility"
        @click="$router.push({ name: 'notifications' }).catch(() => {})"
      >
        <base-icon name="notifications_bell"></base-icon>
        <base-badge
          v-if="notificationsCount > 0"
          v-absolute
          v-top="0"
          v-right="0"
          :count="notificationsCount"
        ></base-badge>
      </base-button>

      <base-button
        v-d-flex
        v-align="{ items: 'center' }"
        v-justify="{ content: 'center' }"
        v-border-radius="'50px'"
        :active="isMenuVisibility"
        style="width: 40px; height: 40px;"
        @click="isMenuVisibility = !isMenuVisibility"
      >
        <base-icon name="basic_more-vertical"></base-icon>
      </base-button>
    </div>

    <header-dropdown-menu
      v-show="isMenuVisibility"
    >
      <header-menu-list
        :menu-list="menuList"
        @logout="$emit('logout')"
      ></header-menu-list>
    </header-dropdown-menu>
  </div>
</template>

<script>
import { isBetaTest } from 'lib/system/env';

import headerMixin from 'lib/mixins/headerMixin';

export default {
  name: 'ApplicationHeaderMobileTemplate',
  mixins: [
    headerMixin,
  ],
  computed: {
    menuList() {
      return [
        {
          icon: this.useSelfEmployed ? 'basic_eagle' : 'basic_CSuser',
          title: 'header.menu.profile',
          action: 'profile',
        },
        isBetaTest() && {
          icon: 'various_sun',
          title: 'header.menu.theme',
          action: 'theme',
        },
        {
          icon: 'chatting_question',
          title: 'header.menu.support',
          action: 'support',
        },
        {
          icon: 'basic_turnoff',
          title: 'header.menu.logout',
          action: 'logout',
        },
      ].filter(i => i);
    },
  },
};
</script>

<style lang="sass" module>
  @import '~styles/components/header/header'
</style>
